var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTabContainer)?_c('div',{staticClass:"tabs",class:{
    light: _vm.isLightTheme,
    dark: !_vm.isLightTheme
  }},[_c('div',{staticClass:"tabs-container",class:{
      light: _vm.isLightTheme,
      dark: !_vm.isLightTheme,
      'min-width': _vm.currentUser && _vm.currentUser.id
    }},[_c('div',{staticClass:"nav-tabs"},[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
          content: 'Presentation',
          trigger: 'hover'
        }),expression:"{\n          content: 'Presentation',\n          trigger: 'hover'\n        }"}],staticClass:"nav-item",class:{
          active: _vm.activeTabView === 'slide',
          light: _vm.isLightTheme,
          dark: !_vm.isLightTheme
        },attrs:{"open-on-click":false},on:{"click":function($event){return _vm.handleSwitchTab('slide')}}},[_c('div',{staticClass:"nav-item-background"}),_c('aha-icon',{staticClass:"nav-item-icon",attrs:{"name":_vm.activeTabView === 'slide' ? 'presenter-solid' : 'presenter-light'}})],1),(_vm.presentation.isEnablePrivateFeedback)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
          content: 'Feedback',
          trigger: 'hover'
        }),expression:"{\n          content: 'Feedback',\n          trigger: 'hover'\n        }"}],staticClass:"nav-item",class:{
          active: _vm.activeTabView === 'feedback',
          light: _vm.isLightTheme,
          dark: !_vm.isLightTheme
        },on:{"click":function($event){return _vm.handleSwitchTab('feedback')}}},[_c('div',{staticClass:"nav-item-background"}),_c('aha-icon',{staticClass:"nav-item-icon",attrs:{"name":_vm.activeTabView === 'feedback' ? 'feedback-solid' : 'feedback'}})],1):_vm._e(),(_vm.isProfileShowing)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
          content: 'My Account',
          trigger: 'hover'
        }),expression:"{\n          content: 'My Account',\n          trigger: 'hover'\n        }"}],staticClass:"nav-item nav-profile",class:{
          active: _vm.activeTabView === 'profile',
          light: _vm.isLightTheme,
          dark: !_vm.isLightTheme
        },on:{"click":function($event){return _vm.handleSwitchTab('profile')}}},[_c('div',{staticClass:"nav-item-background"}),_c('aha-icon',{staticClass:"nav-item-icon nav-item-icon__profile",attrs:{"name":_vm.activeTabView === 'profile' ? 'profile-solid' : (_vm.isLightTheme ? 'profile-light' : 'profile-light-dark')}})],1):_vm._e()])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }